import axiosApiInstance from "./axios";
import cloudfrontApiInstance from "./axiosCloudfront"

const options = {
  crossDomain: true,
  // headers: {
  //   "Replace-Host": process.env.REACT_APP_CDN_DOMAIN,
  // },
};
const APIS = {
  simulacionEnd: async (obj, jwt) => {
    options.headers = {
      authorization: jwt,
    }
    return axiosApiInstance.post(`/advance/simulacion/end`, obj, options);
  },
  simulacionStart: async (obj) => {
    return axiosApiInstance.post(`/advance/simulacion/start`, obj, options);
  },
  startSimulation: async (obj) => {
    return axiosApiInstance.post(`advance/simulacion/start`, obj, options);
  },
  estudiantePut: async (obj, jwt) => {
    options.headers = {
      authorization: jwt,
    }

    return axiosApiInstance.put(`/advance/estudiante/`, obj, options);
  },
  estudianteGet: async (tipoDoc, numDoc) => {
    return axiosApiInstance.get(
      `/advance/estudiante/` + tipoDoc + "/" + numDoc
    );
  },
  getOpeningData: async () => {
    return axiosApiInstance.get(`/aperturas/apertura/2`);
  },
  getCarreras: async () => {
    return cloudfrontApiInstance.get(`/backend_data/carreras_advance.json`);
  },
  getTiposDoc: async () => {
    return cloudfrontApiInstance.get(`/backend_data/tipos_documento.json`);
  },
  getSituacionLaboral: async () => {
    return cloudfrontApiInstance.get(`/backend_data/situacion_laboral.json`);
  },
  getNivelesEstudio: async () => {
    return cloudfrontApiInstance.get(`/backend_data/nivel_de_estudios.json`);
  },
  getFinanciamiento: async () => {
    return cloudfrontApiInstance.get(`/backend_data/financiamiento_carrera.json`);
  },
  sendCertificado: async (obj, certificado, jwt) => {
    options.headers = {
      authorization: jwt,
    }
    return axiosApiInstance.post(
      `/advance/certificado/enviar/` + certificado,
      obj,
      options
    );
  },
};

export default APIS;
